import { FC, ReactNode } from "react";
import { Box, SxProps, Theme, Typography } from "@mui/material";
import CustomIcon from "components/CustomIcon";
import icons from "enums/icons";

interface LegendItemProps {
    label: string;
    subLabel?: string;
    color?: string;
    icon?: ReactNode;
    type?: "userIcon" | "line" | "rectangle" | "square";
    sx?: SxProps<Theme>;
}

const LegendItem: FC<LegendItemProps> = ({ label, subLabel, icon, color = "#1B1B36", type = "rectangle", sx }) => {
    const types = {
        line: <Box sx={{ background: color, width: 13, height: 1.5 }} />,
        rectangle: <Box sx={{ background: color, width: 20, height: 8 }} />,
        square: <Box sx={{ background: color, width: 16, height: 16 }} />,
        userIcon: <CustomIcon icon={icons.userMenu} sx={{ color, fontSize: 14, transform: "translateY(1px)" }} />,
    };

    return (
        <Box sx={{ display: "flex", alignItems: "center", ...sx }}>
            {icon ? icon : <Box sx={{ marginRight: 0.5, border: 0 }}>{types[type]}</Box>}
            <Box>
                <Typography
                    paragraph
                    sx={{ fontSize: 12, fontWeight: 600, color: "text.secondary", margin: 0, textAlign: "left" }}
                >
                    {label}
                </Typography>
                <Typography paragraph sx={{ fontSize: 12, fontWeight: 600, color: "text.disabled", margin: 0 }}>
                    {subLabel}
                </Typography>
            </Box>
        </Box>
    );
};

export default LegendItem;
